export default __webpack_public_path__ + "57ff397dd3fe54467ac2ead30a942cde.jpg";